import React from 'react';
import { Row, Col, Divider } from 'antd';
import { SkyscraperMobile } from 'components/Ads';
import { useRouter } from 'next/router';
import Content from 'layout/Basic/Content';
import Sider from 'layout/Basic/Sider';
import Section, { SectionTitle } from 'components/Section';
import Pagination from 'components/Pagination';
import AppSmallLogotypeIcon from 'components/Icons/AppSmallLogotype';
import OurIssueSection from 'components/OurIssueSection';
import Newsletter from 'containers/Newsletter';
import Item from 'components/List/ArticleItem';
import styled from 'styled-components';
import ContentProvidersSection from 'components/ContentProvidersSection';
import GalleryBlock from 'components/GalleryBlock';
import VideoBlock from 'components/VideoBlock';
import EventsBlock from 'components/EventsBlock';

const Icon = styled(AppSmallLogotypeIcon)`
    vertical-align: -0.25em;
`;
export interface Props {
    articles: {
        items: Article[];
        results: number;
        currentPage: number;
        numberOfPages: number;
        next: boolean;
        prev: boolean;
        paginate: boolean;
    };
    companies: Company[];
    singleGallery: Gallery;
    singleVideo: Video;
    latestIssue: Issue;
    events: Occurrence[];
    eventsPatronate: Occurrence[];
    whitePapers: WhitePaper[];
    ads: PageAds;
}

export const PremiumPage = ({
    articles,
    singleGallery,
    singleVideo,
    latestIssue,
    events,
    eventsPatronate,
    companies,
    ads
}: Props): React.JSX.Element => {
    const router = useRouter();
    const { items, currentPage, results, next, prev } = articles || {
        items: [],
        currentPage: 1,
        results: 0,
        next: false,
        prev: false
    };

    const onChange = (page) => {
        router.push(`?page=${page}`);
    };
    const { skyscraper } = ads;
    return (
        <>
            <Row gutter={16}>
                <Content>
                    <Row>
                        <Col span={24}>
                            <SectionTitle
                                title={
                                    <>
                                        <Icon style={{ fontSize: 30 }} /> Premium
                                    </>
                                }
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        {items.map((item: Article, i: number) => {
                            if (i === 3) {
                                return (
                                    <Col span={24} key={item.seoSlug}>
                                        <Item $article={item} />
                                        <Row justify="center">
                                            <Col xs={24} sm={12}>
                                                <SkyscraperMobile
                                                    id={skyscraper[0]}
                                                    margin="12px auto 12px auto"
                                                />
                                            </Col>
                                            <Col xs={24} sm={12}>
                                                <SkyscraperMobile
                                                    id={skyscraper[1]}
                                                    margin="12px auto 0 auto"
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                );
                            }

                            return (
                                <Col span={24} key={item.seoSlug}>
                                    <Item $article={item} />
                                </Col>
                            );
                        })}
                    </Row>
                    <Row justify="center">
                        <Col span={24}>
                            <Pagination
                                currentPage={currentPage}
                                results={results}
                                onChange={onChange}
                                next={next}
                                prev={prev}
                            />
                        </Col>
                    </Row>
                    <Divider />
                    <Section gutter={[16, 32]} justify="center">
                        <Col xs={24} md={20}>
                            <Newsletter />
                        </Col>
                    </Section>
                </Content>

                <Sider>
                    <Row gutter={[16, 32]}>
                        <Col span={24}>
                            <ContentProvidersSection companies={companies} />
                        </Col>

                        <Col span={24}>
                            <EventsBlock events={events} eventsPatronate={eventsPatronate} />
                        </Col>

                        {singleGallery && (
                            <Col span={24}>
                                <GalleryBlock gallery={singleGallery} />
                            </Col>
                        )}
                        {singleVideo && (
                            <Col span={24}>
                                <VideoBlock video={singleVideo} />
                            </Col>
                        )}

                        <Col span={24}>
                            <OurIssueSection issue={latestIssue} />
                        </Col>
                    </Row>
                </Sider>
            </Row>
        </>
    );
};

export default PremiumPage;
